import { ref } from 'vue'
import { useUIStore } from '@/stores/ui'
import apiInterceptor from '@/shared/apiInterceptor'
import { environment } from '@/shared/env'

/**
 * Manages the customer detail view state.
 * Owns the view toggle (list ↔ detail) and the single-customer fetch.
 */
export function useCustomerDetail() {
  const _uiStore = useUIStore()

  const customerView = ref('customer-list-view')
  const detailCustomer = ref({})
  const singleUserDetailCustomer = ref(null)

  async function openDetail(customer) {
    if (!customer.conversationid) return

    try {
      _uiStore.updateLoading({ isLoading: true, message: 'Loading customer details...' })
      singleUserDetailCustomer.value = customer

      const response = await apiInterceptor.get(
        environment('VUE_APP_API_URL') + 'crm/v1/customers/' + customer.conversationid,
      )
      const data = response.data
      data.conversationid = customer.conversationid
      data.channel = data.platform
      delete data.platform

      detailCustomer.value = data
      customerView.value = 'customer-info-view'
    } catch (error) {
      _uiStore.updateToast({ open: true, message: error.message, type: 'danger' })
    } finally {
      _uiStore.updateLoading({ isLoading: false })
    }
  }

  function backToList() {
    customerView.value = 'customer-list-view'
  }

  return {
    customerView,
    detailCustomer,
    singleUserDetailCustomer,
    openDetail,
    backToList,
  }
}
